<template>
  <div>
    <el-card>
      <el-tabs v-model="activeTab">
        <el-tab-pane :label="$t('system::exchange-manager::setting')" name="1"></el-tab-pane>
      </el-tabs>
      <Setting></Setting>
    </el-card>
  </div>
</template>

<script>
import Setting from './setting'
export default {
  components: { Setting },
  data() {
    return {
      activeTab: '1'
    }
  }
}
</script>

<style lang="scss" scoped></style>
